import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  // List of paths that should not trigger scroll to top
  const excludePaths = [
    "/academy/for-individuals/",
    "/academy/for-corporates/",
    "/academy/career-advancement-courses/",
    "/academy/professional-growth-courses/",
    "/academy/workshops",
    "/academy/bite-sized-courses/",
    "/ai-readiness-index/for-literacy",
    
  ];
  
  // Define breakpoint for mobile (below this is considered mobile)
  const mobileBreakpoint = 768; // Typically md starts at 768px
  
  // Track window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => {
    // Check if we're on mobile
    const isMobile = windowWidth < mobileBreakpoint;
    
    if (isMobile || !excludePaths.includes(pathname)) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [pathname, windowWidth]);
 
  return null;
};
 
export default ScrollToTop;



// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
 
//  const ScrollToTop = () => {
//   const { pathname } = useLocation();
 
//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   }, [pathname]);
 
//   return null;
// };
 
// export default ScrollToTop;